import IDialogPropTypes from "rc-dialog/lib/IDialogPropTypes";
import React from "react";
import AnimatedDialog from "../AnimatedDialog/AnimatedDialog";

export interface CountDownDialogProps
    extends Exclude<IDialogPropTypes, "children"> {
    readonly seconds: number;
    readonly children: (remainingSeconds: number) => React.ReactNode;
}

export interface CountDownDialogState {
    readonly remainingSeconds: number;
}

export default class CountDownDialog extends React.Component<
    CountDownDialogProps,
    CountDownDialogState
> {
    private interval: number | undefined;

    constructor(props: CountDownDialogProps) {
        super(props);

        this.state = { remainingSeconds: props.seconds };
    }

    public componentDidMount() {
        this.hideWithTimer();
    }

    public componentDidUpdate() {
        this.hideWithTimer();
    }

    public componentWillUnmount() {
        if (this.interval) {
            window.clearInterval(this.interval);
        }
    }

    public render() {
        const { seconds, children, visible = true, ...props } = this.props;
        return (
            <AnimatedDialog
                {...props}
                visible={visible && this.state.remainingSeconds > 0}
            >
                {children(this.state.remainingSeconds)}
            </AnimatedDialog>
        );
    }

    private hideWithTimer() {
        if (!this.interval) {
            this.interval = window.setInterval(this.secondTick, 1000);
        }
    }

    private secondTick = () =>
        this.setState(
            ({ remainingSeconds }) => ({
                remainingSeconds: Math.max(0, remainingSeconds - 1)
            }),
            () => {
                if (this.state.remainingSeconds <= 0) {
                    window.clearInterval(this.interval);
                    this.interval = undefined;
                }
            }
        );
}
